export default "__VITE_ASSET__ee99e8ee__"